import { render, staticRenderFns } from "./ConfigAlertMsTeams.vue?vue&type=template&id=0aa20d4c&scoped=true"
import script from "./ConfigAlertMsTeams.vue?vue&type=script&lang=js"
export * from "./ConfigAlertMsTeams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa20d4c",
  null
  
)

export default component.exports